module.exports = __webpack_public_path__ + "img/elantra-25.cd662d1b.png";